import {Box, Typography} from '@mui/material';
import {Shield} from 'lucide-react';
import React from 'react';
import {useBrandTheme} from '../useBrandTheme';

interface SextingAnonymousLogoProps {
  variant: `light` | `dark`;
}

export const SextingAnonymousLogo: React.FC<SextingAnonymousLogoProps> = ({variant}) => {
  const theme = useBrandTheme();

  const isLight = variant === `light`;

  return (
    <Box
      sx={{
        display: `flex`,
        alignItems: `center`,
        gap: 1,
        userSelect: `none`,
      }}
    >
      <Shield
        size={20}
        style={{
          color: isLight ? theme.custom.colors.ui.white : theme.custom.colors.secondary,
        }}
      />
      <Typography
        sx={{
          fontSize: `20px`,
          fontWeight: 700,
          ...(isLight
            ? {
                color: theme.custom.colors.ui.white,
                textShadow: `0 1px 3px rgba(0, 0, 0, 0.3)`,
              }
            : {
                background: `linear-gradient(135deg, #6b46c1 0%, #8b5cf6 50%, #a855f7 100%)`,
                WebkitBackgroundClip: `text`,
                WebkitTextFillColor: `transparent`,
                backgroundClip: `text`,
              }),
          fontFamily: `"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif`,
          letterSpacing: `-0.5px`,
        }}
      >
        SA
      </Typography>
    </Box>
  );
};
